import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import logoImg from "../assets/logo2.png";

/* ================= UTIL ================= */
const traduzirStatus = (status) => ({
  PAGO: "Pago",
  PENDENTE: "Pendente",
  PARCIAL: "Parcial",
  ATRASADO: "Em atraso",
}[status] || status || "—");

const formatarMesAno = (mes, ano) => {
  if (!mes || !ano) return "—";
  const data = new Date(ano, mes - 1);
  const mesAbrev = data.toLocaleString("pt-PT", { month: "short" });
  return `${mesAbrev.charAt(0).toUpperCase() + mesAbrev.slice(1)}/${ano}`;
};

const formatarDetalhes = (detalhes) => {
  if (!detalhes) return "—";
  if (typeof detalhes === "string") return detalhes;
  if (detalhes.data) {
    const data = new Date(detalhes.data).toLocaleString("pt-PT");
    return detalhes.telefone
      ? `${data} | ${detalhes.telefone}`
      : data;
  }
  return "—";
};

/* ================= EXPORTAÇÃO ================= */
export const exportarMensalidades = (
  mensalidades,
  formato = "pdf",
  titulo = "Relatório de Mensalidades",
  nomeArquivoBase = "mensalidades",
  nomeEscola = "Escola Vida Abundante",
  emailEscola = "escolavidaabundante7@mail.com",
  localizacao = "Matola, Machava Km 15 Nkomane",
  nuit = "700067254",
  operador = "Usuário",
  desenvolvedor = "Chaúca Creative"
) => {
  if (!Array.isArray(mensalidades) || mensalidades.length === 0) {
    alert("Nenhuma mensalidade para exportar.");
    return;
  }

  const nomeArquivo = `ACADE_Mensalidades_${new Date()
    .toLocaleDateString("pt-AO")
    .replace(/\//g, "-")}`;

  /* ================= COLUNAS ================= */
  const colunas = [
    "Código",
    "Aluno",
    "Referência",
    "Entidade",
    "Mês/Ano",
    "Valor",
    "Multa",
    "Saldo",
    "Crédito",
    "Forma Pagamento",
    "Detalhes",
    "Estado",
  ];

  /* ================= DADOS ================= */
  const dados = mensalidades.map(m => ({
    "Código": m.codigo_aluno || "—",
    "Aluno": m.nome_completo || "—",
    "Referência": m.referencia || "—",
    "Entidade": m.entidade || "—",
    "Mês/Ano": formatarMesAno(m.mes, m.ano_lectivo),
    "Valor": `${Number(m.valor_base || 0).toLocaleString("pt-AO")} MZN`,
    "Multa": `${Number(m.valor_multa || 0).toLocaleString("pt-AO")} MZN`,
    "Saldo": `${Number(m.saldo || 0).toLocaleString("pt-AO")} MZN`,
    "Crédito": `${Number(m.credito || 0).toLocaleString("pt-AO")} MZN`,
    "Forma Pagamento":
      m.forma_pagamento && m.forma_pagamento !== "PENDENTE"
        ? m.forma_pagamento
        : "—",
    "Detalhes": formatarDetalhes(m.detalhes),
    "Estado": traduzirStatus(m.estado),
  }));

  /* ================= PDF ================= */
  if (formato === "pdf") {
    const doc = new jsPDF("landscape");
    const img = new Image();
    img.src = logoImg;

    img.onload = () => {
      doc.addImage(img, "PNG", 10, 8, 40, (img.height * 40) / img.width);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text("ACADE – Gestor Escolar", 60, 15);

      doc.setFontSize(12);
      doc.setFont("helvetica", "italic");
      doc.text(titulo, 60, 23);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.text(nomeEscola, 60, 30);
      doc.text(`Email: ${emailEscola}`, 60, 36);
      doc.text(`Localização: ${localizacao}`, 60, 42);
      doc.text(`NUIT: ${nuit}`, 60, 48);

      const now = new Date().toLocaleString("pt-AO");
      doc.text(`Data: ${now}`, 270, 15, { align: "right" });
      doc.text(`Operador: ${operador}`, 270, 21, { align: "right" });

      autoTable(doc, {
        head: [colunas],
        body: dados.map(d => colunas.map(c => d[c])),
        startY: 55,
        styles: { fontSize:10},
        headStyles: {
          fillColor: [22, 160, 133],
          textColor: 255,
          halign: "center",
        },
        didDrawPage: () => {
          const h = doc.internal.pageSize.height;
          const w = doc.internal.pageSize.width;
          const p = doc.internal.getNumberOfPages();
          doc.setFontSize(9);
          doc.text(
            `Software: ACADE-Gestor Escolar | Página ${p} de ${p}`,
            14,
            h - 15
          );
          doc.line(14, h - 13, w - 14, h - 13);
          doc.setFont("helvetica", "italic");
          doc.text(`Desenvolvido por ${desenvolvedor}`, w - 14, h - 8, {
            align: "right",
          });
        },
      });

      doc.save(`${nomeArquivo}.pdf`);
    };
  }

  /* ================= EXCEL ================= */
  if (formato === "excel") {
    const ws = XLSX.utils.json_to_sheet(dados, { header: colunas });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Mensalidades");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout]), `${nomeArquivo}.xlsx`);
  }

  /* ================= CSV ================= */
  if (formato === "csv") {
    const linhas = [
      colunas.join(","),
      ...dados.map(d => colunas.map(c => `"${d[c]}"`).join(",")),
    ];
    saveAs(
      new Blob([linhas.join("\n")], { type: "text/csv;charset=utf-8;" }),
      `${nomeArquivo}.csv`
    );
  }
};
